import React from 'react';
import { skills } from '../data/mock';

const Skills = () => {
  return (
    <section
      id="skills"
      className="py-20 md:py-24 px-6 border-b border-stone-400/25 dark:border-stone-500/20 bg-white/[0.22] dark:bg-stone-950/30"
    >
      <div className="max-w-6xl mx-auto">
        <div className="mb-12">
          <h2 className="text-4xl font-bold text-stone-900 dark:text-stone-100 mb-4 leading-tight">
            Skills & Expertise
          </h2>
          <div className="w-16 h-1 bg-amber-800 dark:bg-amber-600 rounded-full mb-4"></div>
          <p className="text-base text-stone-600 dark:text-stone-400 max-w-2xl">
            Same stack for shipping features and stress-testing them—before users hit the edge cases.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {skills.map((category, index) => (
            <div
              key={index}
              className="p-6 rounded-2xl bg-white/60 dark:bg-stone-800/60 backdrop-blur-md border border-stone-200/50 dark:border-stone-700/50 hover:shadow-xl transition-all hover:-translate-y-1"
            >
              <h3 className="text-lg font-bold text-stone-900 dark:text-stone-100 mb-6">
                {category.category}
              </h3>
              <div className="space-y-4">
                {category.items.map((skill, skillIndex) => (
                  <div key={skillIndex}>
                    <div className="flex justify-between mb-2">
                      <span className="text-sm text-stone-700 dark:text-stone-300 font-medium">
                        {skill.name}
                      </span>
                      <span className="text-sm text-amber-800 dark:text-amber-600 font-medium">{skill.level}%</span>
                    </div>
                    <div className="w-full h-1.5 bg-stone-200 dark:bg-stone-700 rounded-full overflow-hidden">
                      <div
                        className="h-full bg-gradient-to-r from-amber-700 to-amber-600 dark:from-amber-600 dark:to-amber-500 rounded-full transition-all duration-1000 ease-out"
                        style={{ width: `${skill.level}%` }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
